'use client';

import { LeftPanel, PanelContainer, RightPanel } from 'components/ring-air';
import { Carousal } from 'components/m1/Carousel';
import { OffersDataType } from 'components/ring-air/OffersCarousel';
import { isMarketingBannerActive } from 'components/shared/Header/MarketingBanner';
import React from 'react';
import {
  carousalSection_m1,
  carousalSection_m1_eu_gb,
  carousalSection_m1_in,
  carousalSection_m1_us,
} from 'content/m1';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import { useCartStore } from 'components/shared/Cart';
import { BuySection } from './BuySection';
import styles from './ProductSelection.module.css';

export const ProductHeader = ({
  className,
  title = 'Ultrahuman Ring AIR',
}: {
  className?: string;
  title?: string | React.ReactNode;
  mobileOnly?: boolean;
}) => {
  return (
    <div
      className={`u-grid ${styles.productHeader}${
        className ? ` ${className}` : ''
      }`}
    >
      <div className={styles['header-content']}>
        <h3>{title}</h3>
      </div>
    </div>
  );
};

const StickyPanel = ({ children }: { children?: React.ReactNode }) => (
  <div className={styles.stickyPanel}>{children}</div>
);

export const ProductSelectionSection = ({
  className,
  offersData,
}: {
  className?: string;
  offersData?: OffersDataType[];
}) => {
  const store = useCartStore((s) => s.store);
  const { store: regionStore } = useRegionLocale();
  return (
    <section
      className={`u-grid ${styles.root}${className ? ` ${className}` : ''}`}
      style={{ paddingTop: isMarketingBannerActive() ? '80px' : '48px' }}
    >
      <div className={styles.content}>
        <ProductHeader
          title={
            <>
              {store === ShopifyStore.US
                ? 'Ultrahuman M2 Live Glucose Monitoring'
                : 'Ultrahuman M1 Live Glucose Monitoring'}{' '}
              {regionStore !== ShopifyStore.IN ? (
                <span className={styles.dimmed}>(NFC Required)</span>
              ) : null}
            </>
          }
        />
        <PanelContainer>
          <LeftPanel>
            <StickyPanel>
              <Carousal
                items={
                  store === ShopifyStore.US
                    ? carousalSection_m1_us
                    : store === ShopifyStore.IN
                    ? carousalSection_m1_in
                    : store === ShopifyStore.EU || store === ShopifyStore.GB
                    ? carousalSection_m1_eu_gb
                    : carousalSection_m1
                }
                showCaptions={store === ShopifyStore.IN ? true : false}
              />
            </StickyPanel>
          </LeftPanel>
          <RightPanel>
            <BuySection offersData={offersData} />
          </RightPanel>
        </PanelContainer>
      </div>
    </section>
  );
};
